/* What you can build with this pack (sections/clixo-pack-challenges.liquid):
   arrows slide the row; a card opens its video in a pop-up with Clixo's own player
   (YouTube underneath with its UI hidden, same approach as the challenge pages). */
(function () {
  document.querySelectorAll('[data-cxpc]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    /* ---------- row ---------- */
    var track = root.querySelector('[data-cxpc-track]');
    var items = Array.prototype.slice.call(track.children);
    var prevBtn = root.querySelector('[data-cxpc-prev]');
    var nextBtn = root.querySelector('[data-cxpc-next]');
    var idx = 0;
    function perView() { return window.matchMedia('(max-width: 699px)').matches ? 1 : window.matchMedia('(max-width: 999px)').matches ? 2 : 3; }
    function layout() {
      var pv = perView(), max = Math.max(0, items.length - pv);
      if (idx > max) idx = max;
      var step = items[0] ? items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 24) : 0;
      track.style.transform = pv === 1 ? '' : 'translateX(' + (-idx * step) + 'px)';
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= max;
      prevBtn.hidden = nextBtn.hidden = max === 0;
    }
    prevBtn.addEventListener('click', function () { idx = Math.max(0, idx - 1); layout(); });
    nextBtn.addEventListener('click', function () { idx += 1; layout(); });
    window.addEventListener('resize', layout);
    layout();

    /* ---------- pop-up player ---------- */
    var modal = root.querySelector('[data-cxpc-modal]');
    document.body.appendChild(modal); /* out of the section so no parent can clip or stack over it */
    var box = modal.querySelector('[data-cxpc-player]');
    var mount = box.querySelector('[data-cxpc-mount]');
    var cover = box.querySelector('[data-cxpc-cover]');
    var poster = box.querySelector('[data-cxpc-poster]');
    var bar = box.querySelector('[data-cxpc-bar]');
    var toggleBtn = box.querySelector('[data-cxpc-toggle]');
    var seek = box.querySelector('[data-cxpc-seek]');
    var muteBtn = box.querySelector('[data-cxpc-mute]');
    var fsBtn = box.querySelector('[data-cxpc-fs]');
    var titleEl = modal.querySelector('[data-cxpc-title]');
    var linkEl = modal.querySelector('[data-cxpc-link]');
    var usedKeys = false;
    document.addEventListener('keydown', function () { usedKeys = true; }, true);
    document.addEventListener('pointerdown', function () { usedKeys = false; }, true);
    var player = null, ready = false, ticker = null, idleTimer = null, revealTimer = null, seeking = false, lastFocus = null, cur = null;

    function setState(s) {
      box.classList.toggle('is-playing', s === 'playing');
      box.classList.toggle('is-paused', s !== 'playing');
      if (s === 'held') box.classList.add('is-held');
      else if (s === 'ended' || s === 'reset') box.classList.remove('is-held');
      toggleBtn.setAttribute('aria-label', s === 'playing' ? 'Pause' : 'Play');
    }
    function loadApi(cb) {
      if (window.YT && window.YT.Player) return cb();
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) prev(); cb(); };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }
    }
    function tick() {
      if (!player || !ready || seeking) return;
      var d = player.getDuration() || 0, t = player.getCurrentTime() || 0, p = d ? (t / d) * 100 : 0;
      seek.value = Math.round(p * 10);
      seek.style.setProperty('--p', p + '%');
    }
    function poke() {
      box.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { if (box.classList.contains('is-playing')) box.classList.add('is-idle'); }, 2500);
    }
    var nativeMode = false, startAt = 0;
    function create(id) {
      var el = document.createElement('div');
      mount.appendChild(el);
      player = new YT.Player(el, {
        host: 'https://www.youtube-nocookie.com',
        videoId: id,
        playerVars: { autoplay: 1, controls: 0, disablekb: 1, fs: 0, rel: 0, modestbranding: 1, iv_load_policy: 3, playsinline: nativeMode ? 0 : 1, cc_load_policy: 0, cc_lang_pref: 'en', hl: 'en', start: Math.floor(startAt) },
        events: {
          onReady: function (e) {
            ready = true;
            var f = e.target.getIframe();
            f.setAttribute('title', (cur && cur.title || 'Challenge') + ' video');
            f.setAttribute('tabindex', '-1');
            /* no captions: YouTube's auto-generated ones (e.g. "[Music]" in another language) otherwise show, mostly in iPhone full screen */
            try { e.target.unloadModule('captions'); e.target.unloadModule('cc'); e.target.setOption('captions', 'track', {}); } catch (err) {}
            e.target.playVideo();
          },
          onStateChange: function (e) {
            var S = YT.PlayerState;
            if (e.data === S.PLAYING) {
              box.classList.remove('is-loading');
              bar.hidden = false;
              clearTimeout(revealTimer);
              if (box.classList.contains('is-held')) setState('playing');
              else revealTimer = setTimeout(function () { if (player && player.getPlayerState() === S.PLAYING) setState('playing'); }, 700);
              if (!ticker) ticker = setInterval(tick, 250);
              poke();
            } else if (e.data === S.PAUSED) {
              clearTimeout(revealTimer);
              setState(player.getCurrentTime() > 0 ? 'held' : 'paused'); /* keep the paused frame on screen */
            } else if (e.data === S.ENDED) {
              setState('ended');
              seek.value = 1000; seek.style.setProperty('--p', '100%');
            }
          }
        }
      });
    }
    function play() {
      if (player && ready) { player.playVideo(); return; }
      if (player || !cur) return;
      box.classList.add('is-loading');
      bar.hidden = false;
      setState('paused');
      loadApi(function () { create(cur.id); });
    }
    function pause() { if (player && ready) player.pauseVideo(); }
    function toggle() { box.classList.contains('is-playing') ? pause() : play(); }
    function teardown() {
      clearInterval(ticker); ticker = null;
      clearTimeout(revealTimer); clearTimeout(idleTimer);
      if (player && player.destroy) { try { player.destroy(); } catch (e) {} }
      player = null; ready = false;
      mount.innerHTML = '';
      box.classList.remove('is-playing', 'is-paused', 'is-held', 'is-loading', 'is-idle', 'is-muted');
      bar.hidden = true;
      seek.value = 0; seek.style.setProperty('--p', '0%');
    }

    function open(card) {
      nativeMode = false; startAt = 0;
      cur = { id: card.dataset.videoId, title: card.dataset.title };
      teardown();
      cover.style.background = card.dataset.bg || '';
      if (card.dataset.poster) { poster.src = card.dataset.poster; poster.hidden = false; } else { poster.removeAttribute('src'); poster.hidden = true; }
      titleEl.textContent = card.dataset.title;
      linkEl.href = card.dataset.url;
      lastFocus = card;
      modal.hidden = false;
      document.documentElement.classList.add('cxpc-noscroll');
      if (usedKeys) modal.querySelector('.cxpc-modal__x').focus({ preventScroll: true });
      play();
    }
    /* Full screen: the Fullscreen API where it exists (desktop, Android, iPad); iPhone has none for page elements,
       so there the player covers the screen with CSS (turned sideways when the phone is upright: challenge-page.css). */
    var fsEl = box.requestFullscreen ? 'requestFullscreen' : (box.webkitRequestFullscreen ? 'webkitRequestFullscreen' : null);
    function fakeFs(on) {
      box.classList.toggle('is-fakefs', on);
      fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
    }
    function exitFs() {
      if (box.classList.contains('is-fakefs')) fakeFs(false);
      var on = document.fullscreenElement || document.webkitFullscreenElement;
      if (on) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    }
    fsBtn.addEventListener('click', function () {
      if (box.classList.contains('is-fakefs')) return fakeFs(false);
      var on = document.fullscreenElement || document.webkitFullscreenElement;
      if (on) return (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      if (fsEl) {
        var r = box[fsEl]();
        if (r && r.catch) r.catch(function () { fakeFs(true); });
      } else if (/iPhone|iPod/.test(navigator.userAgent)) {
        goNative();
      } else {
        fakeFs(true);
      }
    });
    /* iPhone: only iOS's own video player can fill the screen, so rebuild the player with inline playback off,
       from the same moment; iOS then plays it in its native full-screen player. */
    function goNative() {
      if (!cur) return;
      startAt = player && ready ? (player.getCurrentTime() || 0) : 0;
      if (player && player.destroy) { try { player.destroy(); } catch (e) {} }
      player = null; ready = false;
      mount.innerHTML = '';
      nativeMode = true;
      box.classList.add('is-loading');
      loadApi(function () { create(cur.id); });
    }

    function close() {
      exitFs();
      teardown();
      modal.hidden = true;
      document.documentElement.classList.remove('cxpc-noscroll');
      if (lastFocus && usedKeys) lastFocus.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-cxpc-open]').forEach(function (c) { c.addEventListener('click', function () { open(c); }); });
    modal.querySelectorAll('[data-cxpc-close]').forEach(function (c) { c.addEventListener('click', close); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); if (box.classList.contains('is-fakefs')) fakeFs(false); else close(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(modal.querySelectorAll('button, a[href], input'), function (el) { return !el.closest('[hidden]') && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      if ((e.key === ' ' || e.key === 'k') && e.target !== seek && !e.target.closest('a, .cxpc-modal__actions')) { if (player) { e.preventDefault(); toggle(); } }
    });
    box.querySelector('[data-cxpc-play]').addEventListener('click', play);
    toggleBtn.addEventListener('click', toggle);
    box.addEventListener('click', function (e) { if (!e.target.closest('button, input, [data-cxpc-bar]')) toggle(); });
    box.addEventListener('mousemove', poke);
    box.addEventListener('touchstart', poke, { passive: true });
    seek.addEventListener('input', function () { seeking = true; seek.style.setProperty('--p', (seek.value / 10) + '%'); });
    seek.addEventListener('change', function () {
      seeking = false;
      if (!player || !ready) return;
      player.seekTo((seek.value / 1000) * (player.getDuration() || 0), true);
      if (!box.classList.contains('is-playing')) player.playVideo();
    });
    muteBtn.addEventListener('click', function () {
      if (!player || !ready) return;
      if (player.isMuted()) { player.unMute(); box.classList.remove('is-muted'); muteBtn.setAttribute('aria-label', 'Mute'); }
      else { player.mute(); box.classList.add('is-muted'); muteBtn.setAttribute('aria-label', 'Unmute'); }
    });
  });
})();
